import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppProviders } from "@/app/AppProviders";
import { bootIntegrations } from "@/integrations";
import { getReactRootOptions } from "@/integrations/sentry";
import { getOrCreateAppRoot, initializeAppIntegrations } from "@/lib/app-bootstrap";
import { getQueryClient } from "@/lib/query-client";
import { shouldRenderReactQueryDevtools } from "@/lib/query-devtools";
import App from "./App.tsx";
import "./index.css";

initializeAppIntegrations(document, bootIntegrations);
const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error('Root element "#root" not found.');
}

const root = getOrCreateAppRoot(rootElement, {
  createRoot,
  getRootOptions: getReactRootOptions,
});

root.render(
  <StrictMode>
    <QueryClientProvider client={getQueryClient()}>
      <BrowserRouter>
        <AppProviders>
          <App />
        </AppProviders>
      </BrowserRouter>
      {shouldRenderReactQueryDevtools() ? (
        <ReactQueryDevtools buttonPosition="top-left" initialIsOpen={false} />
      ) : null}
    </QueryClientProvider>
  </StrictMode>,
);
